module.exports = __webpack_public_path__ + "img/pitch_rb.289b3545.png";